import CertificateCard from "./CertificateCard";

export default function Certificates({ CertificatesList }) {
  return (
    <section
      id="certificates"
      className="relative bg-[#0F2419] text-[#F1E9D8] px-6 md:px-10 py-32 grain"
    >
      <div className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 w-[26rem] h-[26rem] rounded-full bg-[#D4AF6A] opacity-[0.06] blur-[130px]" />

      <div className="max-w-5xl mx-auto relative">
        <div className="flex items-center justify-center gap-4 mb-16">
          <span className="text-sm text-[#D4AF6A]">03</span>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <h2 className="font-display text-4xl md:text-5xl font-light">
            Certificates
          </h2>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <span className="text-sm text-[#D4AF6A]">03</span>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center">
          {CertificatesList.map((certificate, index) => (
            <CertificateCard key={index} {...certificate} />
          ))}
        </div>
      </div>
    </section>
  );
}
